import { createAction, props } from '@ngrx/store';
import { C4ListResponse } from '@domain/interface/c4-list-response';
import { ImportStatsTable, Owner } from 'cargo-chief-commons';
import { ImportStatUpdated } from '@domain/interface/import-stat-updated';

export const AUTOMATION_RFP = {
	RFP_LIST: {
		GET: createAction('[Automation RFP] Get rfps', props<any>()),
		SUCCESS: createAction(
			'[Automation RFP] Get rfps success',
			props<C4ListResponse<ImportStatsTable>>()
		),
		FAILURE: createAction(
			'[Automation RFP] Get rfps failure',
			props<{ payload: { message: string } }>()
		),
	},

	SORT: {
		SET: createAction('[SORT] RFP Automation Set sort', props<{ sort: any[] }>()),
	},

	FILTERS: {
		SET: createAction('[FILTERS] RFP Automation Set filters', props<{ filters: any[] }>()),
	},

	USERS_LIST: {
		SET: createAction(
			'[UsersList] Set Users List for RFP automation',
			props<{ usersList: Owner[] }>()
		),
	},

	ACTIVE_TAB: {
		SET: createAction('[ACTIVE_TAB] Automation RFP Set ACTIVE_TAB', props<{ activeTab: string }>()),
	},

	IMPORT_RFP_UPLOAD_FILE: {
		OPEN_DIALOG: createAction('[Automation RFP] open import rfp dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Automation RFP] close import rfp dialog', props<any>()),
		UPLOAD: createAction('[Automation RFP] import rfp', props<any>()),
		SUCCESS: createAction('[Automation RFP] import rfp success', props<any>()),
		FAILURE: createAction(
			'[Automation RFP] import rfp failure',
			props<{ payload: { message: string } }>()
		),
	},

	IMPORT_STAT: {
		ADD: createAction('[Automation RFP] Import stat added', props<ImportStatUpdated>()),
		UPDATE: createAction('[Automation RFP] Import stat updated', props<ImportStatUpdated>()),
	},
};
